var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Approval Object Type")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approvalType),
      expression: "approvalType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Client",
      "value": "client",
      "name": "approvalType"
    },
    domProps: {
      "checked": _vm._q(_vm.approvalType, "client")
    },
    on: {
      "__c": function($event) {
        _vm.approvalType = "client"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Client"
    }
  }, [_vm._v("Client ")]), _vm._v("     \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approvalType),
      expression: "approvalType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Contract",
      "value": "contract",
      "name": "approvalType"
    },
    domProps: {
      "checked": _vm._q(_vm.approvalType, "contract")
    },
    on: {
      "__c": function($event) {
        _vm.approvalType = "contract"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Contract"
    }
  }, [_vm._v("Contract")]), _vm._v("     \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approvalType),
      expression: "approvalType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Rate",
      "value": "rate",
      "name": "approvalType"
    },
    domProps: {
      "checked": _vm._q(_vm.approvalType, "rate")
    },
    on: {
      "__c": function($event) {
        _vm.approvalType = "rate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Rate"
    }
  }, [_vm._v("Rate")])])])], 1)]), _vm._v(" "), (_vm.approvalType != '') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Company Short Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "id": "companyname",
      "options": _vm.CompanyShortNameArr,
      "placeholder": "Select Company Name",
      "name": "companyName",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientId),
      expression: "clientId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "clientId",
      "id": "clientId",
      "placeholder": "Enter Client ID"
    },
    domProps: {
      "value": (_vm.clientId)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.clientId = $event.target.value
      }, _vm.removeClientComanyName]
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                    "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)]) : _vm._e()])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Approval Logs")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalrows))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "isEditHidden": true,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('b-card', [_c('h4', {
    staticClass: "header"
  }, [_vm._v("Approval Logs")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "background-color": "#D0D3D4",
      "height": "1px"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action By")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action Comment")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Next Action By")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getLogsList), function(column, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.moduleactionby))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm.format_date(column.moduledate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.approvestatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.modulecomment))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(column.modulenextactionby))])])
  }))]), _c('br'), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.viewFlag
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tableItems.length != 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.pageCount,
      "total": _vm.totalrows,
      "per-page": 10,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c94036","hasScoped":true}!./src/modules/reporting/views/ApprovalLogs/approvalLogs/approvalLogs.component.html
// module id = 887
// module chunks = 3